import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-700 to-blue-500 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-black/40 backdrop-blur-md shadow-xl rounded-lg p-8 border border-blue-500/20">
        <Link
          to="/"
          className="inline-flex items-center text-cyan-300 hover:text-cyan-200 transition-colors mb-8 group"
        >
          <ArrowLeft className="h-5 w-5 mr-2 transition-transform group-hover:-translate-x-1" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-white mb-8 bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">Terms of Service</h1>
        
        <div className="space-y-8 text-lg">
          <p className="text-cyan-200">Last updated: January 23, 2025</p>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">1. Acceptance of Terms</h2>
            <p className="text-gray-300 leading-relaxed">
              By accessing or using AIX services, you agree to be bound by these Terms of Service and all applicable laws and regulations.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">2. User Accounts</h2>
            <p className="text-gray-300 leading-relaxed">
              You are responsible for maintaining the security of your account and password. AIX cannot and will not be liable
              for any loss or damage from your failure to comply with this security obligation.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">3. Acceptable Use</h2>
            <p className="text-gray-300 leading-relaxed">
              You agree not to use the service for any unlawful purpose or in any way that could damage, disable, overburden,
              or impair our servers or networks.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">4. Termination</h2>
            <p className="text-gray-300 leading-relaxed">
              We reserve the right to terminate or suspend access to our service immediately, without prior notice or liability,
              for any reason whatsoever.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">5. Changes to Terms</h2>
            <p className="text-gray-300 leading-relaxed">
              We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new
              Terms of Service on this page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
